module.exports = "/_next/static/images/Trend05Visual-04f8c73440563bf74b1cd37409c8a815.webp";